<template>
  <div id="about-preview"
  class="grid-item"
  v-scroll-reveal>
    <div class="about-preview-content">
      <h2><b>Dan Araujo</b> is a Product Designer based in Chicago, IL.</h2>
      <p>I’m a designer with a passion for UI/UX, motion, and code. I apply a detail-oriented, user-first mindset on every step of a project, from strategy to production to adding the final coat of (digital) paint.</p>
    </div>

    <router-link
    tag="div"
    class="about-preview-link"
    :to="{path: '/about'}">

      <img src="/img/emoji/arrow_right.svg" alt="">

      <b>View skills, experience, and contact info</b>

      <div class="about-preview-color"></div>
    </router-link>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  props: []

}

</script>

<style lang="scss" scoped>
#about-preview {
    background-color: $black;
    color: $gray1;
    background-image: url('/img/general/city.jpg');
    background-size: cover;
    background-position: center;
    background-blend-mode: soft-light;

    grid-area: about;
    width: 100%;
    height: 100%;
    padding-right: $grid-gap*2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    @include tablet-below {
      order: 4;
      padding: 0;
    }

    .about-preview-content {
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      padding: $grid-gap 0 $grid-gap $grid-gap*2;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @include tablet-below {
        padding: $grid-gap*2;
      }

      @include phone-only {
        padding: $grid-gap*2 $grid-gap;
      }

      h2 {
        font-weight: 400;
        margin-bottom: 1rem;
        line-height: 140%;
      }

      p {
        line-height: 180%;
      }
    }

    .about-preview-link {
      width: 100%;
      padding: $grid-gap $grid-gap $grid-gap $grid-gap*2;
      border-top: 1px solid $gray3;
      box-sizing: border-box;
      position: relative;
      white-space: pre;
      @extend %linkify;

      @include tablet-below {
        white-space: initial;
      }

      @include phone-only {
        padding: $grid-gap;
      }

      b, img, span {
        position: relative;
        z-index: 9;
        transition: all 200ms ease-out;
      }

      b {
        color: $white;
        line-height: 160%;
      }

      img {
        width: 24px;
        margin-right: 12px;
        margin-bottom: -5px;
      }

      .about-preview-color {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        opacity: 0;
        pointer-events: none;
        transition: opacity 200ms ease-out;
        background-color: $gray8;
      }

      &:hover {
        .about-preview-color {
          opacity: 1;
        }
        b {
          color: $white ;
        }
        img {
          transform: rotate(90deg)
        }
      }
    }
}
</style>
